import { CustomNode } from '../../../types';
import { fieldsMatchIcon } from '../../../icons';

const DEFAULT_ICON = fieldsMatchIcon;

export const fieldsMatchConfig: CustomNode = {
  getNodeConfig() {
    return {
      icon: DEFAULT_ICON,
    };
  },
};
